import { isNetworkOffline } from '@alfa-bank/newclick-helpers/utils/is-network-offline';
import { isAxiosError } from '../axios/is-axios-error';
const NETWORK_ERROR_CODES = ['ENETUNREACH', 'ECONNABORTED', 'ENOTCONN'];
/**
 * Возвращает `true`, если ошибка возникла из-за проблем с интернетом
 * @param error Ошибка от сервиса
 */
const networkErrorMessage = 'Network Error';
export function isNetworkError(error) {
    if (isNetworkOffline()) {
        return networkErrorMessage;
    }
    if (isAxiosError(error)) {
        const { response, code = '', message } = error;
        return (typeof response === 'undefined' &&
            (NETWORK_ERROR_CODES.includes(code) || message === networkErrorMessage));
    }
    return false;
}
